import React from 'react';
import classnames from 'classnames';
import classes from './blog-posts.scss';
export default class BlogPosts extends React.Component {
  renderPost(post) {
    const {
      liClassName,
      linkClassName
    } = this.props;
    return /*#__PURE__*/React.createElement("li", {
      key: `post-${post.id}`,
      className: liClassName
    }, /*#__PURE__*/React.createElement("a", {
      className: linkClassName,
      href: post.link,
      rel: "noreferrer",
      target: "_blank",
      dangerouslySetInnerHTML: {
        __html: post.title.rendered
      }
    }));
  }
  render() {
    const {
      posts,
      ulClassName
    } = this.props;
    return /*#__PURE__*/React.createElement("ul", {
      className: classnames(classes.list, ulClassName)
    }, posts && posts.map(this.renderPost.bind(this)));
  }
}